import { createTheme } from '@eduact/student-theme'

export const primaryTheme = createTheme({})
